import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

import { SaveChangesModalService } from '../../services/helper-service/save-changes-modal.service';
export interface CanComponentDeactivate {
  hasUnsavedChanges: () => boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard
  implements CanDeactivate<CanComponentDeactivate>
{
  constructor(private readonly _modalService: SaveChangesModalService) {}

  public canDeactivate(
    component: CanComponentDeactivate
  ): Observable<boolean> | boolean {
    if (component.hasUnsavedChanges()) {
      // Trigger the modal and return the user's decision
      return this._modalService.showSaveChangesModal();
    }
    return true; // Allow navigation if there are no unsaved changes
  }
}
